import React, { Component } from 'react';

import "./../styles/formTextItem.css";
import "./../styles/PagSobreLaApp.css";

import logoPsi from "../images/sobreLaApp/psicologia_isologo.png";
import logoTec5 from "../images/sobreLaApp/logo_tec5.png";
import logoBa from "../images/sobreLaApp/logo-ba.jpg";
import logoMgp from "../images/sobreLaApp/mgp_salud.png";

export default class PagMasInfo extends Component {
    
    render() {
        return (
            <React.Fragment>
                <div className="card formTextItem">
                    <h1>Sobre Tranqui</h1>
                    <div className="About">
                        <p className="Paragraph">
                            Tranqui App es una herramienta para la prevención del suicidio, que apunta al acompañamiento 
                            en crisis y a la psicoeducación sobre esta problemática. Por eso, está pensada para ser 
                            utilizada por personas que están atravesando esta situación, familiares, amigxs, profesionales 
                            de salud, docentes, entre otros. 
                        </p>
                        <p className="Paragraph">
                            Todo el contenido de Tranqui App ha sido desarrollado siguiendo las recomendaciones de la 
                            Organización Mundial de la Salud, el Ministerio de Salud de la Nación Argentina, UNICEF, y 
                            de asociaciones nacionales e internacionales que se dedican a la prevención del 
                            suicidio -International Association for Suicide Prevention, Fundación Salud Mental España, 
                            y American Association of Suicidology-.
                        </p>
                        <p className="Paragraph">
                            Toda la información personal que los usuarios guarden en la app es confidencial y se encuentra 
                            encriptada. 
                        </p>
                        <div className="Credits">
                            <p>Mg. Aixa Galarza. Facultad de Psicología. Universidad Nacional de Mar del Plata.</p>
                            <p>Lic. Santiago González. Jefe de Salud Mental de la Municipalidad de General Pueyrredón.</p>
                            <p>Est. Dario Funes. Est. Lucas Funes. Prof. Pablo Abdala Achaval. E.E.S.T. N°5 "Amancio Williams" Mar del Plata.</p>
                        </div>

                        <div className="Logos">
                            <img src={logoTec5} alt="Logo escula tecnica 5" style={{width: "25%"}}/>
                            <img src={logoPsi} alt="Logo facultad de Psicologia" style={{width: "48%"}}/>
                            <img src={logoMgp} alt="Logo Salud MGP" style={{width: "25%"}}/>
                            <img src={logoBa} alt="Logo Provincia de Bs. As." style={{width: "60%"}}/>
                        </div>
                    </div>
                    
                </div>
                
                 </React.Fragment>
        )
    }
}